import { Container } from "@mui/material";
import React from "react";
import KontaktniFormular from "../components/Base/KontaktniFormular";

export default function ContactForm() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        px: "0px !important",
        position: "relative",
      }}
    >
      <KontaktniFormular />
    </Container>
  );
}
